import React from 'react';

export interface User {
  id: string;
  name: string;
  email: string;
  username?: string;
  avatarUrl?: string | null;
  isAdmin?: boolean;
}

interface UserContextType {
  user: User | null;
  addUser: (user: User) => void;
  removeUser: () => void;
  isLoading: boolean;
}

const UserContext = React.createContext<UserContextType>({
  user: null,
  addUser: () => {},
  removeUser: () => {},
  isLoading: true,
});

export default UserContext;
